module.exports = __webpack_public_path__ + "img/06展前快訊.926c99da.jpg";